import * as React from 'react';
import * as PXBColors from '@brightlayer-ui/colors';
import Archive from '@mui/icons-material/Archive';
import { Status } from '../../types';
import { ListItemTag } from '@brightlayer-ui/react-components/core/ListItemTag';

export const StatusTag: React.FC<{
    status: string;
    style?: React.CSSProperties;
}> = (props) => (
    <>
        {props.status === Status.Active && (
            <ListItemTag
                label={'Active'}
                backgroundColor={PXBColors.green[500]}
                fontColor={PXBColors.white[500]}
                style={{ ...props.style }}
            />
        )}

        {(props.status === Status.Pending || props.status === Status.InActive) && (
            <ListItemTag
                label={props.status === Status.Pending ? 'Pending' : 'InActive'}
                backgroundColor={PXBColors.gray[500]}
                fontColor={PXBColors.white[500]}
                style={{ ...props.style }}
            />
        )}

        {props.status === Status.Unassigned && (
            <ListItemTag
                label={'Unassigned'}
                backgroundColor={PXBColors.gold[500]}
                fontColor={PXBColors.white[500]}
                style={{ ...props.style }}
            />
        )}

        {props.status === Status.Configured && (
            <ListItemTag
                label={'Configured'}
                backgroundColor={PXBColors.gold[500]}
                fontColor={PXBColors.white[500]}
                style={{ ...props.style }}
            />
        )}

        {props.status === Status.Archive && (
            <Archive fontSize="small" style={{ color: PXBColors.gray[500], ...props.style }} />
        )}
        {props.status === Status.Online && (
            <ListItemTag
                label={'Online'}
                backgroundColor={PXBColors.green[500]}
                fontColor={PXBColors.white[500]}
                style={{ ...props.style }}
            />
        )}
        {props.status === Status.Offline && (
            <ListItemTag
                label={'Offline'}
                backgroundColor={PXBColors.gray[500]}
                fontColor={PXBColors.white[500]}
                style={{ ...props.style }}
            />
        )}
        {props.status === Status.UnSupported && (
            <ListItemTag
                sx={{ border: 2 }}
                label={'Unsupported'}
                backgroundColor={PXBColors.white[50]}
                fontColor={PXBColors.black[500]}
            />
        )}
    </>
);
